export default __webpack_public_path__ + "static/media/378.0d139ff2.jpg";